import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#243E81",
    stroke: "#243E81",
    viewBox: "0 0 33 33",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<circle cx="16.543" cy="16.648" r="15.5" fill="none" stroke="inherit"/> <path fill="inherit" d="M10.498 15.846h12v1.606h-12z" stroke="none"/>' }
  })
);